require('./_wks-define')('observable');



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/es7.symbol.observable.js
 ** module id = 283
 ** module chunks = 0
 **/